import * as React from "react";
const SvgFiRrWaterRise = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-water-rise_svg__a)">
      <path d="M21 24a4.38 4.38 0 0 1-3-1.226 4.334 4.334 0 0 1-6 0 4.334 4.334 0 0 1-6 0 4.184 4.184 0 0 1-5.668.2 1 1 0 0 1 1.336-1.49 2.2 2.2 0 0 0 3.387-.815 1 1 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.006 1.006 0 0 1 1.89 0 2.277 2.277 0 0 0 4.11 0 1.006 1.006 0 0 1 1.89 0 2.2 2.2 0 0 0 3.388.817 1.002 1.002 0 0 1 1.622.407 1 1 0 0 1-.287 1.082A4 4 0 0 1 21 24M21 19a4.38 4.38 0 0 1-3-1.226 4.334 4.334 0 0 1-6 0 4.334 4.334 0 0 1-6 0 4.184 4.184 0 0 1-5.668.2 1 1 0 0 1 1.336-1.49 2.2 2.2 0 0 0 3.387-.815 1.007 1.007 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.006 1.006 0 0 1 1.89 0 2.277 2.277 0 0 0 4.11 0 1 1 0 0 1 1.89 0 2.2 2.2 0 0 0 3.388.817 1.002 1.002 0 0 1 1.622.407 1 1 0 0 1-.287 1.082A4 4 0 0 1 21 19M15.705 3.293l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.415L11 3.415V11a1 1 0 1 0 2 0V3.415l1.3 1.293a1 1 0 0 0 1.413-1.415z" />
    </g>
    <defs>
      <clipPath id="fi-rr-water-rise_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWaterRise;
